/**
 * First letter uppercase
 * @param {*} string 
 */ 
export const Ucfirst = (string) => {
    if (typeof string !== "string") { return "" }
    return string.charAt(0).toUpperCase() + string.slice(1)
}